<template>
    <div>
        <buttonlist @help="help" @search="search" @reflash="reflash"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tHeight + 'px' }">
            <li class="left" ref="left">
                <el-button type="primary" size="mini" @click="addSet()" icon="el-icon-circle-plus">{{$t('getapi[878]')}}</el-button>
                <el-table
                id="xpane-0"
                :data="dataSet"
                ref="singleTable"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                @row-click="edits"
                @row-dblclick="openEdit"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:2px"
                >
                    <el-table-column show-overflow-tooltip prop="DeviceCategoryID" :label="$t('getapi[13647]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="DeviceCategoryName" :label="$t('getapi[13648]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="CreateUserName" :label="$t('getapi[410]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="CreateTime" :label="$t('getapi[409]')">
                            <template scope="scope">
                            {{$limits.getDateType(scope.row.CreateTime)}}
                            </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="ModifyUserName" :label="$t('getapi[733]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="ModifyTime" :label="$t('getapi[1210]')">
                        <template scope="scope">
                            {{$limits.getDateType(scope.row.ModifyTime)}}
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('getapi[6048]')" width="80" fixed="right">
                        <template slot-scope="scope" >
                            <el-button  @click.native.prevent="editSet(scope.row)"  type="text" size="small">{{ $t('getapi[34]') }}</el-button>
                            <el-popconfirm
                                    :confirmButtonText="$t('getapi[937]')"
                                    :cancelButtonText="$t('getapi[6]')"
                                    icon="el-icon-info"
                                    iconColor="red"
                                    :title="$t('getapi[637]')"
                                    @onConfirm="delSet(scope.row)"
                            >
                                <el-button  slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="display: flex">
                    <el-button type="primary" size="mini" @click="addline()" icon="el-icon-circle-plus">{{$t('getapi[878]')}}
                    </el-button>
                </div>
                <el-table
                        id="xdetilpane-0"
                        :data="dataDetail"
                        ref="singleTable1"
                        v-loading="dloading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:3px"
                >
                    <el-table-column type="selection" v-if="dataDetail.Order_Status == 0"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Line_No" :label="$t('getapi[1425]')"></el-table-column>
                </el-table>


            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">
                    {{$t('getapi[7980]')}}:{{ DbTbNames }}
                </div>
            </el-col>
        </el-row>


        <serce :isVisible="isVisibleSet" queryData="DeviceCategory" ref="ser" @getser="serclick"></serce>

        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="isVisibleSet" :title="$t('getapi[34]')" width="30%" :close-on-click-modal="false">
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[13648]')}}</td>
                        <td><el-input v-model="dataSetList.DeviceCategoryName" type="text" size="mini" ></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[143]')}}</td>
                        <td><el-input v-model="dataSetList.Remark" type="textarea" size="mini" ></el-input></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isVisibleSet = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="saveSet" :loading="loading" :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: '5_devicecategorylist',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3 - Common.reduceTableHeight3
            },
            tHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('5_devicecategorylist'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                loading: false, // 主表加载状态
                dataDetail: [],
                code: '',
                scrollTop: 0,
                scrollTop1: 0,
                isVisibleSet: false,
                dataSetList:{},
                addoreditset: 1, //1:新增 2 编辑
                dloading: false,

            };
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.$limits.dragControllerDiv();
            that.$nextTick(function () {
                that.$processdata.initForm(0)
                that.$processdata.initFormRight(0)
            })
            that.authority()
        },
        activated() {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                }, false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                }, false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop = this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop = this.scrollTop1;
                }, 13)
            })
        },
        methods: {
            help() {
                this.$refs.SetBtn.showHelp(this.$options.name, this.$t("getapi[13646]"), this.$t("getapi[13646]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if (that.$loadviewfields.isEnableHelp(this.$options.name) == 1) {
                    that.$refs.SetBtn.SetOneBtnEnable('help', true);
                }
                that.$refs.SetBtn.SetButtonEnable('search,refresh');
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                if (!that.iscontinuedblclick) {
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit() {
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('5_devicecategorylist', val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'DeviceCategory');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.pageIndex = 1;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },

            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Maintenance/DeviceCategoryList', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        }
                        that.$nextTick(function () {
                            that.$processdata.initForm(0)
                        });
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                });
            },
            edits(){

            },
            addSet(){
                let that = this
                that.isVisibleSet = true
                that.addoreditset = 1
                that.dataSetList = {
                    DeviceCategoryID: '',
                    DeviceCategoryName:'',
                    Remark: '',
                    DeviceType: 0,
                };
            },
            editSet(row){
                let that = this
                that.isVisibleSet = true
                that.addoreditset = 2
                that.dataSetList = {
                    DeviceCategoryID: row.DeviceCategoryID,
                    DeviceCategoryName: row.DeviceCategoryName,
                    Remark: row.Remark,
                    DeviceType: row.DeviceType,
                };
            },
            delSet(row){
                let that = this
                let parm = {
                    DeviceCategoryID : row.DeviceCategoryID
                }
                that.$http.urlpost('/Maintenance/DeleteDeviceCategory', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[659]'));
                        that.isVisible = false;
                        that.getView();
                    }
                    that.loading = false;
                });
            },
            saveSet(){
                let that = this
                let parm = that.dataSetList
                if(that.addoreditset == 1) {
                    that.$http.urlpost('/Maintenance/AddDeviceCategory', parm, function(res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[284]'));
                            that.isVisibleSet = false;
                            that.getView();
                        }
                    });
                } else if (that.addoreditset == 2) {
                    that.$http.urlpost('/Maintenance/EditDeviceCategory', parm, function(res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[284]'));
                            that.isVisibleSet = false;
                            that.getView();
                        }
                    });
                }
            },
            checkDataChange() {
                let that = this
                let datacopy = that.dataDetail
                for (let i = 0; i < datacopy.length; i++) {
                    delete datacopy[i]['index']
                }
                let flag = that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    span.title .el-switch {
        display: inline-block;
        margin: 8px 30px;
    }

    .box {
        width: 100%;
        .bbl {
            margin: 0px auto 10px;
            white-space: pre;
            span {
                margin-left: 10px;
                min-width: 70px;
                text-align: left;
                line-height: 20px;
                display: inline-block;
                margin-right: 0px;
            }
        }
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }

    /deep/ .red {
        background: #ff7879;
    }
</style>
